const errorCls = "c2le1ebuy92";
const iconCls = "c2liv60bvd";
const textCls = "c2ltppgn00";
const buttonCls = "c2lb1nlywoz";
const buttonTextCls = "c2lbp2t5qd";
const loadingEllipsisCls = "c2ll1wixvvk";

export { buttonCls, buttonTextCls, errorCls, iconCls, loadingEllipsisCls, textCls };
import "./error.style.linaria.module.css";
//# sourceMappingURL=error.style.js.map
